// Translates Chit Chats Print / WS-flow error codes into user-facing strings.
//
// The print app surface is small enough to map flat: code → message-key. If a
// future code shows up that we don't have a mapping for, we fall back to
// the raw error message (or "unknown_error" if even that's missing).
//
// For codes in DETAIL_APPENDED_CODES, we append the print app's raw error
// alongside the localized template. The localized message gives the user
// "what went wrong"; the appended detail gives ops "why" without making
// them dig through print app logs. Hides poorly behind a "Details:" prefix.

const CODE_TO_MESSAGE_KEY = {
  // Client-side (ws_flow.js)
  PRINT_APP_UNREACHABLE: "print_app_unreachable",
  PRINT_APP_DROPPED: "print_app_unreachable",
  WEBSOCKET_UNSUPPORTED: "print_app_unavailable",
  REQUEST_TIMEOUT: "print_app_timeout",
  PRINTER_REQUIRED: "select_printer_error",
  USER_CANCELED: "zpl_canceled",

  // Chit Chats Print orchestrator
  BAD_REQUEST: "unknown_error",
  EMPTY_JOB: "no_labels_available",
  ALL_FETCHES_FAILED: "download_failed",
  JOB_TOO_LARGE: "job_too_large",
  PRINT_JOB_IN_PROGRESS: "print_job_in_progress",
  MERGE_FAILED: "pdf_merge_failed",
  PRINT_FAILED: "print_command_failed"

  // PARTIAL_FAILURE is intentionally absent — its `message` is already
  // a rendered count ("3 of 99 failed; 96 printed") that we want to
  // surface verbatim. The fallback path picks up error.message, which is
  // exactly what we want.
};

// Codes where the underlying error is genuinely useful — append it so
// the operator can see the actual stderr / qpdf complaint / OS reply.
const DETAIL_APPENDED_CODES = {
  BAD_REQUEST: true,
  ALL_FETCHES_FAILED: true,
  JOB_TOO_LARGE: true,
  MERGE_FAILED: true,
  PRINT_FAILED: true
};

function appendDetail(baseMessage, rawMessage) {
  if (!rawMessage) {
    return baseMessage;
  }
  return baseMessage + " Details: " + rawMessage;
}

function translatedFromCode(message, code) {
  var key = CODE_TO_MESSAGE_KEY[code];
  return key ? message(key) : "";
}

function fallbackMessage(message, error) {
  var rawMessage = (error && error.message) || "";
  return rawMessage || message("unknown_error");
}

function maybeAppendDetail(translated, code, error) {
  if (!DETAIL_APPENDED_CODES[code]) {
    return translated;
  }
  return appendDetail(translated, (error && error.message) || "");
}

function resolveErrorMessage(message, error) {
  var code = (error && error.code) || "";
  var translated = translatedFromCode(message, code);
  if (!translated) {
    return fallbackMessage(message, error);
  }
  return maybeAppendDetail(translated, code, error);
}

function resolveUserMessage(message, error) {
  if (typeof error === "string") {
    return error;
  }
  return resolveErrorMessage(message, error);
}

function createPrintErrorMapper(message) {
  return {
    toUserMessage(error) {
      return resolveUserMessage(message, error);
    }
  };
}

export { createPrintErrorMapper };
